const validate = (values, props) => {

    let errors = {};

    if (!values.email) {
        errors.email = 'Required';
    }

    return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./assets/app/login/components/ForgotForm/validate.js